import { number, object, string, z } from "zod";

import { FormsWrapper } from "@/models/utils.models";

export const SearchSelectCitiesDto = FormsWrapper(
  object({
    country: string(),
    uid: number(),
  }),
);

export type SearchSelectCitiesDto = z.infer<typeof SearchSelectCitiesDto>;
